module.exports = __webpack_public_path__ + "static/agami-7e389b6f7991c5ffca33843837381e84.mp4";